import HighlightedPickersModal from './HighlightedPickersModal.vue'

export default HighlightedPickersModal
